module.exports = __webpack_public_path__ + "img/4.e68594d1.jpg";